import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';

import PageviewIcon from '@material-ui/icons/Pageview';

import {
  CardWithHeader,
  CustomTable,
  RenderOrEmpty,
} from '../index';
import {LoadingLayout} from '../../layouts-common';

import {setFilter, setSearchOption} from '../../app-common/Insights/action';
import {FILTERS, TABS} from '../../app-common/Insights/constants';
import {PERIODS, ROUTES} from '../../constants';

import style from '../../styles/components/cards';

function TopDomainsCard(props) {
  const {
    classes,
    headers,
    tableData,
    textWhenDataNotAvailable,
    title,
    titleColor,
    widgetKey,
    insightsFilterValue,
    selectedPeriodIndex,
    selectedCampusId,
    campuses,
  } = props;
  const dispatch = useDispatch();

  const thereIsNotData = tableData.length === 0;
  return (
    <CardWithHeader
        cardTitle={(
          <div
          className={classes.card__title_withActions}
          onClick={() => {
            dispatch(setSearchOption(TABS.DOMAIN, FILTERS.RESULT, insightsFilterValue));
            dispatch(
              setSearchOption(
                TABS.DOMAIN,
                'period',
                Object.values(PERIODS)[selectedPeriodIndex],
              ),
            );
            if (selectedCampusId) {
              const campus = campuses.find((c) => c.id === selectedCampusId);
              const index = campuses.findIndex((c) => c.id === selectedCampusId);
              dispatch(
                setFilter(
                  TABS.DOMAIN,
                  FILTERS.SITE,
                  {value: [{index, label: campus.name}], isApplied: true},
                ),
              );
            }
            props.history.push(ROUTES.INSIGHTS);
          }}
          >
            {title}
            <PageviewIcon />
          </div>
        )}
        cardTitleColor={titleColor}
        content={(
          <LoadingLayout widgetKey={widgetKey}>
            <RenderOrEmpty isShow={thereIsNotData}>
              <h3 className={classes.topBlock__thereIsNotData}>
                {textWhenDataNotAvailable}
              </h3>
            </RenderOrEmpty>
            <RenderOrEmpty isShow={!thereIsNotData}>
              <CustomTable
                tableHead={headers}
                tableData={tableData}
              />
            </RenderOrEmpty>
          </LoadingLayout>
        )}
    />
  );
}

TopDomainsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
  textWhenDataNotAvailable: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  widgetKey: PropTypes.string.isRequired,
  insightsFilterValue: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  selectedPeriodIndex: PropTypes.number,
  selectedCampusId: PropTypes.string,
  campuses: PropTypes.array,
};

TopDomainsCard.defaultProps = {
  selectedPeriodIndex: 0,
  selectedCampusId: undefined,
  campuses: [],
};

export default withStyles(style)(withRouter(TopDomainsCard));
